import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { t } from 'utils/translates';
import {
  setQueryParams,
  sendRequest,
  selectItemsIds,
  selectItemById
} from 'mt-react-common/common/reducers/_list/reducer';
import { selectRequestStatusData } from 'mt-react-common/common/reducers/_requestStatus/reducer';
import { selectPaginationData } from 'mt-react-common/common/reducers/_pagination/reducer';
import { selectUserId } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import qs from 'querystring';

import PaginationBlock from '../../Common/Pagination/PaginationBlock/index';

import MediumPreLoader from '../../Common/PreLoaders/MediumPreLoader';
import CommentFormRWrapper from '../ReducerWrappers/CommentFormRWrapper';
import CommentItem from '../CommentItem/index';
import CommentStat from '../CommentStat/CommentStat';

class Comments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      queryParams: {
        page: 1
      },
      queryParamsStatic: {
        ...{
          model_class: this.props.modelClass,
          model_id: this.props.modelId
        },
        ...this.props.queryParamsStatic
      }
    };
    this.sendRequest();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.location.search !== prevProps.location.search &&
      this.props.location.pathname === prevProps.location.pathname &&
      this.props.location.hash === prevProps.location.hash
    ) {
      this.sendRequest();
    }
  }

  setQueryParams = queryParams => {
    this.state.queryParams = { ...this.state.queryParams, ...queryParams };
    this.props.setQueryParams({
      ...this.state.queryParams,
      ...this.state.queryParamsStatic
    });
  };

  updateHistory = () => {
    this.context.router.history.push({
      pathname: this.props.location.pathname,
      search: `?${qs.stringify(this.state.queryParams)}`
    });
  };

  sendRequest = () => {
    this.setQueryParams(qs.parse(this.props.location.search.slice(1)));
    this.props.sendRequest();
  };

  render() {
    let comments = null;
    if (this.props.requestStatusData.requestInProcess) {
      comments = <MediumPreLoader />;
    } else if (this.props.itemsIds.length > 0) {
      comments = (
        <React.Fragment>
          {this.props.itemsIds.map(itemId => (
            // eslint-disable-next-line react/no-array-index-key
            <CommentItem
              key={`commentItem${itemId}`}
              comment={this.props.selectItemById(itemId)}
              reducerName={this.props.reducerName}
            />
          ))}
          <PaginationBlock
            paginationData={this.props.paginationData}
            handlePageClick={pageNumber => {
              this.setQueryParams({ page: pageNumber });
              this.updateHistory();
            }}
          />
        </React.Fragment>
      );
    } else if (this.props.modelClass === 'User') {
      comments = (
        <div className="alert alert-default text-center">
          <p>{t('У пользователя нет комментариев')} :-(</p>
        </div>
      );
    } else if (this.props.modelClass === 'Tasks') {
      comments = (
        <div className="alert alert-default text-center">
          <p>{t('У задачи нет комментариев')} :-(</p>
        </div>
      );
    } else {
      comments = (
        <div className="alert alert-default text-center">
          <p>{t('Нет комментариев')} :-(</p>
        </div>
      );
    }

    return (
      <React.Fragment>
        {this.props.authUserId.toString() ===
        this.props.commentsOwnerId.toString() ? (
          <div
            className="panel panel-default panel-heading_padding-large panel-body_bg-sub panel-footer_padding-large"
            id="reviews"
          >
            <CommentStat commentsStat={this.props.commentsInStat} />
          </div>
        ) : (
          <CommentFormRWrapper
            modelClass={this.props.modelClass}
            modelId={this.props.modelId}
            commentsOwnerId={this.props.commentsOwnerId}
            listReducerName={this.props.reducerName}
            commentsInStat={this.props.commentsInStat}
          />
        )}
        {comments}
      </React.Fragment>
    );
  }
}

Comments.defaultProps = {
  queryParamsStatic: {}
};

Comments.propTypes = {
  modelClass: PropTypes.string.isRequired,
  modelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  queryParamsStatic: PropTypes.shape({}),
  commentsOwnerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  reducerName: PropTypes.string.isRequired,
  commentsInStat: PropTypes.shape({
    dislikes: PropTypes.number.isRequired,
    neutral: PropTypes.number.isRequired,
    likes: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
  }).isRequired,

  setQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired,
  requestStatusData: PropTypes.shape({
    requestInProcess: PropTypes.bool.isRequired
  }).isRequired,
  paginationData: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired,

  authUserId: PropTypes.string.isRequired,

  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
    hash: PropTypes.string.isRequired
  }).isRequired
};

Comments.contextTypes = {
  router: PropTypes.shape()
};

const mapStateToProps = (state, props) => ({
  requestStatusData: selectRequestStatusData(props.reducerName, state),
  paginationData: selectPaginationData(props.reducerName, state),
  itemsIds: selectItemsIds(state, props.reducerName),
  selectItemById: id => selectItemById(state, props.reducerName, id),
  authUserId: selectUserId(state)
});

const mapDispatchToProps = (dispatch, props) => ({
  setQueryParams: queryParams =>
    dispatch(setQueryParams(props.reducerName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.reducerName))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Comments)
);



// WEBPACK FOOTER //
// ./src/components/Comment/CommentsList/Comments.js